import * as lazy from "./lazyRouteComponents";

export default [
  {
    path: "",
    component: lazy.CompanyAdminSection,
    children: [
      {
        path: "",
        name: "companyAdmin:dashboard",
        component: lazy.Dashboard
      },
      {
        path: "users",
        name: "companyAdmin:users",
        component: lazy.UserList
      },
      {
        path: "users/:userId/edit",
        name: "companyAdmin:userEdit",
        component: lazy.EditUser
      },
      {
        path: "users/new",
        name: "companyAdmin:userCreate",
        component: lazy.CreateUser
      },
      {
        path: "users/import",
        name: "companyAdmin:userImport",
        component: lazy.ImportUsers
      },
      {
        path: "permissions",
        name: "companyAdmin:permissions",
        component: lazy.PermissionIndex
      },
      {
        path: "permissions/group/new",
        name: "companyAdmin:groupCreate",
        component: lazy.CreateGroup
      },
      {
        path: "permissions/group/:groupId/edit",
        name: "companyAdmin:groupUpdate",
        component: lazy.EditGroup
      }
    ]
  }
];
